export default {
  apiKey: "AIzaSyDbYKZ1yuijxSdIsQK1oR2lAzKKt8rSQeU",
  databaseURL: "https://tranpo-b47b0.firebaseio.com/"
};



// WEBPACK FOOTER //
// ./src/firebase.config.js